/* Global Buy search: normalize queries (lowercase, no accents, no apostrophes, single spaces) and send exact
   department / brand searches straight to that collection. Map comes from window.GB_SEARCH_MAP. */
(function () {
  'use strict';
  var M = window.GB_SEARCH_MAP || {};
  // lowercase, fold accents (Café -> cafe), drop apostrophes (TV's -> tvs), single spaces
  function norm(s) {
    s = String(s || '');
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[‘’'`]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function key(s) {
    return norm(s).replace(/[^a-z0-9& ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  // map keys get the same treatment, so "café" and "cafe" both resolve
  var K = {};
  Object.keys(M).forEach(function (k) { K[key(k)] = M[k]; });
  function isSearchForm(f) {
    var a = f.getAttribute('action') || '';
    return /\/search\/?(\?|$)/.test(a) && f.querySelector('input[name="q"]');
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !isSearchForm(f)) return;
    var input = f.querySelector('input[name="q"]');
    var q = norm(input.value);
    if (!q) { e.preventDefault(); input.focus(); return; }
    input.value = q;
    var hit = K[key(q)];
    if (hit) { e.preventDefault(); location.href = hit.u; return; }
    if (!f.querySelector('[name="sort_by"]')) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'sort_by'; h.value = 'price-descending';
      f.appendChild(h);
    }
  }, true);

  // Direct visits to /search?q=TV (bookmarks, old links): normalize the URL the same way.
  if (location.pathname.replace(/\/$/, '') === '/search') {
    var p = new URLSearchParams(location.search), q = p.get('q');
    if (q != null) {
      var n = norm(q), hit = K[key(n)];
      if (hit && !p.get('page')) { location.replace(hit.u); return; }
      var changed = false;
      if (n !== q) { p.set('q', n); changed = true; }
      if (!p.get('sort_by')) { p.set('sort_by', 'price-descending'); changed = true; }
      if (changed) location.replace(location.pathname + '?' + p.toString());
    }
  }
})();
